import utils from '@eitje/utils'
import {parseT} from '@eitje/bridge'
import {Layout} from '~/components/layout'
import {Text} from '~/components/text'
import {Icon} from '~/components/icon'
import './index.less'

export const BaseEitjeButton = ({
	iconColor,
	iconLibrary,
	iconLeftProps,
	iconRightProps,
	disabled,
	height: size = 'regular',
	width,
	dropdown,
	iconLeft,
	iconRight,
	ref,
	baseColor = 'blue',
	hasHover = !disabled,
	children,
	className,
	onClick,
	truncate = true,
	t = {},
	fontFamily,
	popoutTitle,
	countSuffix,
	padding,
	colorSet = 'grey-bordered',
	...otherProps
}) => {
	const content = children || parseT(t)
	const iconRightOverride = dropdown ? 'chevron-small-down' : iconRight
	const iconOnly = (iconLeft || iconRightOverride) && !content

	const renderIcon = ({icon, placement, iconProps, size}) => {
		if (!icon) return null

		return (
			<Icon
				name={icon}
				size={size}
				className={`icon-${icon}-${placement}`}
				initialFill={iconColor}
				iconLibrary={iconLibrary}
				{...iconProps}
			/>
		)
	}

	const classNameOverride = utils.makeCns(
		'eitje-button',
		className,
		hasHover && 'pointer-cursor',
		colorSet === 'initial-transparent' && 'no-shadow',
	)
	const colorSetOverride = disabled ? 'disabled' : colorSet

	const getStyleConfig = () => {
		const largePadding = [0, 16]
		const miniPadding = [0, 8]

		switch (size) {
			case 'mini':
				return {
					weight: {semiBold: true},
					height: 24,
					padding: padding || miniPadding,
					labelSize: 'small',
					gap: 4,
					iconSize: 10,
				}
			case 'small':
				return {
					weight: {bold: true},
					height: 32,
					gap: 8,
					padding: padding || (iconOnly ? miniPadding : [0, 12]),
					iconSize: 14,
				}
			case 'large':
				return {
					weight: {bold: true},
					height: 48,
					gap: 8,
					labelSize: 'large',
					padding: padding || largePadding,
					iconSize: 14,
				}
			default:
				return {
					weight: {bold: true},
					height: 40,
					gap: 8,
					padding: padding || largePadding,
					iconSize: 14,
				}
		}
	}

	const {weight, height, gap, labelSize, padding: paddingOverride, iconSize} = getStyleConfig()

	return (
		<Layout
			ref={ref}
			onClick={!disabled && onClick}
			className={classNameOverride}
			padding={paddingOverride}
			colorSet={colorSetOverride}
			hasHover={hasHover}
			baseColor={baseColor}
			width={width}
			height={height}
			gap={gap}
			disabled={disabled}
			tooltip={popoutTitle}
			{...otherProps}
		>
			{renderIcon({icon: iconLeft, placement: 'left', iconProps: iconLeftProps, size: iconSize})}
			{content && !iconOnly && (
				<Text
					{...weight}
					size={labelSize}
					countSuffix={countSuffix}
					className="eitje-button-text"
					noTextSelect
					truncate={truncate}
					fontFamily={fontFamily}
				>
					{utils.capitalize(content)}
				</Text>
			)}
			{renderIcon({icon: iconRightOverride, placement: 'right', iconProps: iconRightProps, size: iconSize})}
		</Layout>
	)
}
